import React, { useState } from "react";
import Banner from "../Components/Home/shared/banner.jsx";
import Categories from "../Components/Home/Categories.jsx";
import HomeGiftCardsSection from "../Components/Home/HomeGiftCardsSection.jsx";
import Choose from "../Components/Home/shared/Choose.jsx";
import Testimonial from "../Components/Home/shared/Testimonial.jsx";
import Newsletter from "../Components/Home/shared/Newsletter.jsx";
import PartnerLogoSlider from "../Components/Home/shared/PartnerLogoSlider.jsx";

const Home = () => {
  const [searchCategory, setSearchCategory] = useState("");
  return (
    <>
      <main>
        <Banner setSearchCategory={setSearchCategory} />
        <Categories searchCategory={searchCategory} />
        {/* <HomeGiftCardsSection title="Trending Gift Cards" collection="" /> */}
        <HomeGiftCardsSection title="Featured" collection="featured" />
        <HomeGiftCardsSection title="New Arrivals" collection="newArrival" />
        <HomeGiftCardsSection title="Best Selling" collection="bestSelling" />
        <HomeGiftCardsSection title="Offers" collection="offers" />
        <Choose />
        <Testimonial />
        <Newsletter />
        <PartnerLogoSlider />
      </main>
    </>
  );
};

export default Home;
